<div class="info-box footer-disclaimer-box" *ngIf="display" [ngClass]="{ 'white-font': environmentName === environments.FONTE }">
    <app-icon
      name="exclamation-outline"
      [size]="24"
      color="#ffc609"
      class="info-box__icon">
    </app-icon>
    <div class="info-box__content">
      <p *ngIf="environmentName !== environments.SINNGEBER">{{ 'contribute.warning.processing' | translateLang }}</p>
      <p *ngIf="contributionType !== contributionOther">
        <ng-container [ngSwitch]="environmentName">
          <ng-container *ngSwitchCase="environments.SINNGEBER">
            <div *ngIf="isPublic; else sinngeberFooterPrivate">
              {{ 'contribute.footer.note_public' | translateLang | translateCut : 0 }}
              <br /><br />
              <p class="mb-1" [innerHTML]="'contribute.footer.info' | translateLang | translateCut : 0"></p>
              <ul class="m-0">
                <li>{{ 'contribute.footer.info' | translateLang | translateCut : 1 }}</li>
                <li>{{ 'contribute.footer.info' | translateLang | translateCut : 2 }}</li>
                <li>{{ 'contribute.footer.info' | translateLang | translateCut : 3 }}</li>
              </ul>
              <br />
              <p
                class="mb-1"
                [innerHTML]="'contribute.footer.info' | translateLang : { portalUrl: portalLoginLink } | translateCut : 4"
              ></p>
              <p
                class="mb-1"
                [innerHTML]="'contribute.footer.info' | translateLang : { homeUrl: homepageLink } | translateCut : 5"
              ></p>
            </div>
            <ng-template #sinngeberFooterPrivate>
              {{ 'contribute.footer.note_private' | translateLang }}
              <br /><br />
              <p class="mb-1" [innerHTML]="'contribute.footer.info' | translateLang | translateCut : 0"></p>
              <ul class="m-0">
                <li>{{ 'contribute.footer.info' | translateLang | translateCut : 1 }}</li>
                <li>{{ 'contribute.footer.info' | translateLang | translateCut : 2 }}</li>
                <li>{{ 'contribute.footer.info' | translateLang | translateCut : 3 }}</li>
              </ul>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <p class="m-0 info-box__secondary-text">{{ 'contribute.warning.fees' | translateLang }}</p>
          </ng-container>
        </ng-container>
      </p>
    </div>
  </div>
